import { Group } from './types';

const GROUPS: Group[] = [
  {
    name: 'Currency',
    symbols: [
      { icon: '¢', name: 'cent', label: 'Cents'},
      { icon: '€', name: 'euro', label: 'Euros'},
      { icon: '£', name: 'pound', label: 'Pounds'},
      { icon: '¥', name: 'yen', label: 'Yen'},
      { icon: '¤', name: 'currency', label: 'Currency'},
    ],
  },
  {
    name: 'Math',
    symbols: [
      { icon: '−', name: 'minus', label: 'Minus'},
      { icon: '±', name: 'plusmn', label: 'Plus minus'},
      { icon: '÷', name: 'divide', label: 'Divide'},
      { icon: '×', name: 'times', label: 'Multiply'},
      { icon: '¼', name: 'frac14', label: 'One quarter'},
      { icon: '½', name: 'frac12', label: 'One half'},
      { icon: '¾', name: 'frac34', label: 'Three quarters'},
      { icon: '⅓', name: 'frac13', label: 'One third'},
      { icon: '⅔', name: 'frac23', label: 'Two thirds'},
      { icon: '⅛', name: 'frac18', label: 'One eighth'},
      { icon: '⅜', name: 'frac38', label: 'Three eighths'},
      { icon: '⅝', name: 'frac58', label: 'Five eighths'},
      { icon: '⅞', name: 'frac78', label: 'Seven eighths'},
      { icon: '⁄', name: 'frasl', label: 'Fraction slash'},
      { icon: '≤', name: 'le', label: 'Less-than or equal to'},
      { icon: '≥', name: 'ge', label: 'Greater-than or equal to'},
      { icon: '≈', name: 'asymp', label: 'Almost equal'},
      { icon: '≠', name: 'ne', label: 'Not equal'},
      { icon: '∞', name: 'infin', label: 'Infinity'},
    ],
  },
  {
    name: 'Units',
    symbols: [
      { icon: '°', name: 'deg', label: 'Degrees'},
      { icon: '′', name: 'prime', label: 'Minutes / feet'},
      { icon: '″', name: 'Prime', label: 'Seconds / inches'},
      { icon: '§', name: 'sect', label: 'Section'},
      { icon: '¶', name: 'para', label: 'Paragraph'},
    ],
  },
  {
    name: 'Quotations',
    symbols: [
      { icon: '‹', name: 'lsaquo', label: 'Single left-pointing'},
      { icon: '›', name: 'rsaquo', label: 'Single right-pointing'},
      { icon: '«', name: 'laquo', label: 'Left-pointing guillemet'},
      { icon: '»', name: 'raquo', label: 'Right-pointing guillemet'},
      { icon: '‘', name: 'lsquo', label: 'Left single'},
      { icon: '’', name: 'rsquo', label: 'Right single'},
      { icon: '“', name: 'ldquo', label: 'Left double'},
      { icon: '”', name: 'rdquo', label: 'Right double'},
      { icon: '‚', name: 'sbquo', label: 'Single low-9'},
      { icon: '„', name: 'bdquo', label: 'Double low-9'},
    ],
  },
  {
    name: 'Punctuation',
    symbols: [
      { icon: '¿', name: 'iquest', label: 'Inverted question mark'},
      { icon: '¡', name: 'iexcl', label: 'Inverted exclamation mark'},
    ],
  },
  {
    name: 'Typography',
    symbols: [
      { icon: '·', name: 'middot', label: 'Middle dot'},
      { icon: '•', name: 'bull', label: 'Bullet'},
      { icon: '…', name: 'hellip', label: 'Three-dot leader'},
      { icon: '–', name: 'ndash', label: 'En dash'},
      { icon: '—', name: 'mdash', label: 'Em dash'},
      { icon: '¯', name: 'macr', label: 'Macron'},
      { icon: '‾', name: 'oline', label: 'Overline'},
      { icon: '¦', name: 'brvbar', label: 'Broken bar'},
    ],
  },
  {
    name: 'Accents',
    symbols: [
      { icon: 'À', name: 'Agrave', label: 'A grave'},
      { icon: 'Á', name: 'Aacute', label: 'A acute'},
      { icon: 'Â', name: 'Acirc', label: 'A circumflex'},
      { icon: 'Ã', name: 'Atilde', label: 'A tilde'},
      { icon: 'Ä', name: 'Auml', label: 'A diaeresis'},
      { icon: 'Å', name: 'Aring', label: 'A ring'},
      { icon: 'à', name: 'agrave', label: 'a grave'},
      { icon: 'á', name: 'aacute', label: 'a acute'},
      { icon: 'â', name: 'acirc', label: 'a circumflex'},
      { icon: 'ã', name: 'atilde', label: 'a tilde'},
      { icon: 'ä', name: 'auml', label: 'a diaeresis'},
      { icon: 'å', name: 'aring', label: 'a ring'},
      { icon: 'È', name: 'Egrave', label: 'E grave'},
      { icon: 'É', name: 'Eacute', label: 'E acute'},
      { icon: 'Ê', name: 'Ecirc', label: 'E circumflex'},
      { icon: 'Ë', name: 'Edia', label: 'E diaeresis'},
      { icon: 'è', name: 'egrave', label: 'e grave'},
      { icon: 'é', name: 'eacute', label: 'e acute'},
      { icon: 'ê', name: 'ecirc', label: 'e circumflex'},
      { icon: 'ë', name: 'edia', label: 'e diaeresis'},
      { icon: 'Ì', name: 'Igrave', label: 'I grave'},
      { icon: 'Í', name: 'Iacute', label: 'I acute'},
      { icon: 'Î', name: 'Icirc', label: 'I circumflex'},
      { icon: 'Ï', name: 'Idia', label: 'I diaeresis'},
      { icon: 'ì', name: 'igrave', label: 'i grave'},
      { icon: 'í', name: 'iacute', label: 'i acute'},
      { icon: 'î', name: 'icirc', label: 'i circumflex'},
      { icon: 'ï', name: 'idia', label: 'i diaeresis'},
      { icon: 'Ò', name: 'Ograve', label: 'O grave'},
      { icon: 'Ó', name: 'Oacute', label: 'O acute'},
      { icon: 'Ô', name: 'Ocirc', label: 'O circumflex'},
      { icon: 'Õ', name: 'Otilde', label: 'O tilde'},
      { icon: 'Ö', name: 'Ouml', label: 'O diaeresis'},
      { icon: 'Ø', name: 'Oslash', label: 'O slash'},
      { icon: 'ò', name: 'ograve', label: 'o grave'},
      { icon: 'ó', name: 'oacute', label: 'o acute'},
      { icon: 'ô', name: 'ocirc', label: 'o circumflex'},
      { icon: 'õ', name: 'otilde', label: 'o tilde'},
      { icon: 'ö', name: 'ouml', label: 'o diaeresis'},
      { icon: 'ø', name: 'oslash', label: 'o slash'},
      { icon: 'Ù', name: 'Ugrave', label: 'U grave'},
      { icon: 'Ú', name: 'Uacute', label: 'U acute'},
      { icon: 'Û', name: 'Ucirc', label: 'U circumflex'},
      { icon: 'Ü', name: 'Uuml', label: 'U diaeresis'},
      { icon: 'Ý', name: 'Yacute', label: 'Y acute'},
      { icon: 'Ÿ', name: 'Yuml', label: 'Y diaeresis'},
      { icon: 'ù', name: 'ugrave', label: 'u grave'},
      { icon: 'ú', name: 'uacute', label: 'u acute'},
      { icon: 'û', name: 'ucirc', label: 'u circumflex'},
      { icon: 'ü', name: 'uuml', label: 'u diaeresis'},
      { icon: 'ý', name: 'yacute', label: 'y acute'},
      { icon: 'ÿ', name: 'yuml', label: 'y diaeresis'},
      { icon: 'Ç', name: 'Ccedil', label: 'C cedilla'},
      { icon: 'Ñ', name: 'Ntilde', label: 'N tilde'},
      { icon: 'Š', name: 'Scaron', label: 'S caron'},
      { icon: 'THORN', name: 'THORN', label: 'THORN'},
      { icon: 'ç', name: 'ccedil', label: 'c cedilla'},
      { icon: 'ñ', name: 'ntilde', label: 'n tilde'},
      { icon: 'š', name: 'scaron', label: 's caron'},
      { icon: 'þ', name: 'thorn', label: 'thorn'},
    ],
  },
  {
    name: 'Ligature',
    symbols: [
      { icon: 'Æ', name: 'AElig', label: 'AE ligature'},
      { icon: 'Œ', name: 'OElig', label: 'OE ligature'},
    ],
  },
  {
    name: 'Greek',
    symbols: [
      { icon: 'Α', name: 'Alpha', label: 'Alpha'},
      { icon: 'Β', name: 'Beta', label: 'Beta'},
      { icon: 'Γ', name: 'Gamma', label: 'Gamma'},
      { icon: 'Δ', name: 'Delta', label: 'Delta'},
      { icon: 'Ε', name: 'Epsilon', label: 'Epsilon'},
      { icon: 'Ζ', name: 'Zeta', label: 'Zeta'},
      { icon: 'Η', name: 'Eta', label: 'Eta'},
      { icon: 'Θ', name: 'Theta', label: 'Theta'},
      { icon: 'Ι', name: 'Iota', label: 'Iota'},
      { icon: 'Κ', name: 'Kappa', label: 'Kappa'},
      { icon: 'Λ', name: 'Lambda', label: 'Lambda'},
      { icon: 'Μ', name: 'Mu', label: 'Mu'},
      { icon: 'Ν', name: 'Nu', label: 'Nu'},
      { icon: 'Ξ', name: 'Xi', label: 'Xi'},
      { icon: 'Ο', name: 'Omicron', label: 'Omicron'},
      { icon: 'Π', name: 'Pi', label: 'Pi'},
      { icon: 'Ρ', name: 'Rho', label: 'Rho'},
      { icon: 'Σ', name: 'Sigma', label: 'Sigma'},
      { icon: 'Τ', name: 'Tau', label: 'Tau'},
      { icon: 'Υ', name: 'Upsilon', label: 'Upsilon'},
      { icon: 'Φ', name: 'Phi', label: 'Phi'},
      { icon: 'Χ', name: 'Chi', label: 'Chi'},
      { icon: 'Ψ', name: 'Psi', label: 'Psi'},
      { icon: 'Ω', name: 'Omega', label: 'Omega'},
      { icon: 'α', name: 'alpha', label: 'alpha'},
      { icon: 'β', name: 'beta', label: 'beta'},
      { icon: 'γ', name: 'gamma', label: 'gamma'},
      { icon: 'δ', name: 'delta', label: 'delta'},
      { icon: 'ε', name: 'epsilon', label: 'epsilon'},
      { icon: 'ζ', name: 'zeta', label: 'zeta'},
      { icon: 'η', name: 'eta', label: 'eta'},
      { icon: 'θ', name: 'theta', label: 'theta'},
      { icon: 'ι', name: 'iota', label: 'iota'},
      { icon: 'κ', name: 'kappa', label: 'kappa'},
      { icon: 'λ', name: 'lambda', label: 'lambda'},
      { icon: 'μ', name: 'mu', label: 'mu'},
      { icon: 'ν', name: 'nu', label: 'nu'},
      { icon: 'ξ', name: 'xi', label: 'xi'},
      { icon: 'ο', name: 'omicron', label: 'omicron'},
      { icon: 'π', name: 'pi', label: 'pi'},
      { icon: 'ρ', name: 'rho', label: 'rho'},
      { icon: 'ς', name: 'sigmaf', label: 'Final sigma'},
      { icon: 'σ', name: 'sigma', label: 'sigma'},
      { icon: 'τ', name: 'tau', label: 'tau'},
      { icon: 'υ', name: 'upsilon', label: 'upsilon'},
      { icon: 'φ', name: 'phi', label: 'phi'},
      { icon: 'χ', name: 'chi', label: 'chi'},
      { icon: 'ψ', name: 'psi', label: 'psi'},
      { icon: 'ω', name: 'omega', label: 'omega'},
    ],
  }
];

export default GROUPS;
